import { render } from "./EditPayrollDeductions.vue?vue&type=template&id=5b8f605c&scoped=true"
import script from "./EditPayrollDeductions.vue?vue&type=script&lang=js"
export * from "./EditPayrollDeductions.vue?vue&type=script&lang=js"

import "./EditPayrollDeductions.vue?vue&type=style&index=0&id=5b8f605c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8f605c"]])

export default __exports__